import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const CustomTitle = styled.h1`
  color: white;
  padding-left: 32px;
  padding-right: 32px;
  text-align: center;
  font-size: 8vw;
  line-height: 1.1;
  letter-spacing: -0.03em;
  font-family: Graphik-Medium,Graphik-Regular,'Gotham SSm A','Gotham SSm B','Helvetica Neue',Helvetica,Arial,sans-serif;

  div {
    display: inline-block;
    background-color: white;
    border-radius: 5px;
    padding: 0 8px;
  }

  span {
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    background-image: linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  @media (width >= 540px) {
    font-size: 6.5vw;
  }

  @media (width >= 1151px) {
    font-size: 4vw;
    text-align: left;
    padding-left: 140px;
    padding-right: 0;
    white-space: pre-line;
  }
`;

export const StyledImage = styled(Image)`
  position: absolute;
  bottom: 0;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  margin: auto;
  text-align: center;

  ${breakpointsMedia({
    xs: css`
      height: ${props => `${props.screenHeight - 420}px`};
      min-height: 230px;
      max-height: ${props => `${props.screenWidth}px`};
      width: auto;
      max-width: 100%;
    `,
    md: css`
      height: ${props => `${props.screenHeight - (props.screenHeight / 2.3)}px`};
    `,
    lg: css`
      height: auto;
      width: 100%;
    `,
  })}
`;

export const StyledBackgroundImage = styled(Image)`
  width: 90%;

  @media (height <= 780px) {
    width: 50%;
    margin: 0 auto;
  }

  @media (width >= 768px ) {
    width: 50%;
    margin: 0 auto;
  }

  @media (width >= 1150px) {
    width: 60%;
  }
`;

export const StyledContainerBox = styled(Box)`
  display: grid;
  grid-template-areas: "title" "image" "formbox";
  grid-template-columns: 1fr;

  @media (width >= 1150px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 
    "title image"
    "formbox image";
  }
`;

export const TitleContainer = styled(Box)`
  grid-area: title;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (width >= 1150px) {
    margin-top: 40px;
  }
`;

export const ImageContainer = styled(Box)`
  grid-area: image;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FormBoxContainer = styled(Box)`
  grid-area: formbox;

  @media (width >= 1150px) {
    padding-left: 140px;
    align-items: start;
    margin-top: 32px;
  }
`;
